import { Socket } from 'phoenix'

function Channel(Vue, socket, topic, opts) {
  var self = this;

  self.socket = socket;
  self.channel = undefined;
  self.topic = topic;
  self.opts = opts;
  self.type = _.get(opts, "type", "old");
  self.connection_type = _.get(opts, "connection_type", "data");
  self.vm = new Vue({
    data: {
      data: {}
    },
    computed: {
      id_list: function() {
        if(self.connection_type == "list") {
          return _.keys(this.data);
        }
        return [];
      },
      list: function() {
        if(self.connection_type == "list") {
          return _.values(this.data);
        }
        return [];
      }
    }
  });
  self.data = {};
  self.refs = 0;
  self.callbacks = {};
  self.callbackRef = 0;

  self.$set = function(value) {
    if(self.type == "new") {
      self.vm.$set(self.vm, "data", value);
    } else {
      Vue.set(self, "data", value);
    }
  }

  self.__init__ = function(create_on_callbacks) {
    if(!self.channel) {
      self.channel = self.socket.channel(self.topic);

      if(_.isEmpty(create_on_callbacks) || create_on_callbacks == true) {

        if(self.connection_type == "list") {
          console.log("List channel created", self.topic);
          self.channel.on("init", (msg) => {
            var data = msg[self.opts.init_key];

            var new_data = _.reduce(data, (acc, item) => {
              acc[item.id] = item;
              return acc;
            }, {});
            self.$set(new_data);
          });

          self.channel.on("update", (msg) => {
            var data = msg[self.opts.update_key];
            Vue.set(self.vm.data, data.id, data);
          });

          self.channel.on("delete", (msg) => {
            var data = msg[self.opts.delete_key];
            Vue.delete(self.vm.data, data.id);
          });
        } else {
          self.channel.on("init", (msg) => {
            self.$set(msg);
          });

          self.channel.on("update", (msg) => {
            self.$set(msg);
          });

          self.channel.on("data", (msg) => {
            self.$set(msg.data);
          });
        }

      }

    }
  }

  self.watch = function(cb, key) {
    if(typeof(cb) != "function") {
      console.error("Watch callback must be a function");
      return;
    }
    if(_.isEmpty(key)) key = "data";
    return self.vm.$watch(key, (newVal, oldVal) => {
      console.log("Watch callback", self.topic, newVal, oldVal);
      cb(newVal, oldVal);
    }, {deep: true, immediate: true});
  }

  self.on = function(name, cb) {
    if(self.channel) {
      if(!self.callbacks[name]) {
        self.callbacks[name] = [];
        self.channel.on(name, function(...args) {
          _.each(self.callbacks[name], ({callback}) => {
            callback(...args);
          });
        });
      }
      var ref = self.callbackRef++;
      self.callbacks[name].push({callback: cb, ref: ref});
      return ref;
    } else {
      return undefined;
    }
  }

  self.off = function(name, delete_ref) {
    self.callbacks[name] = _.filter(self.callbacks[name], ({ref}) => { return ref != delete_ref; });
  }

  self.join = function(...args) {
    self.refs++;

/*  Debuggausta varten 
    const err = new Error();
    const pino = err.stack.split("\n");
    const callerLine = pino[2].trim();;
    console.error("Joining channel", self.topic, "refs", self.refs,"from",callerLine);*/

    if(self.channel && self.refs == 1 && !self.channel.joinedOnce) {
      return self.channel.join(...args);
    } else if (self.channel) {
      return undefined;
    }
    throw "Channel "+self.topic+" not found!";
  }

  self.leave = function(...args) {
    if(self.refs > 0) self.refs--;

/*  Debuggausta varten
    const err = new Error();
    const pino = err.stack.split("\n");
    const callerLine = pino[2].trim();;
    console.error("Leaving channel", self.topic, "refs", self.refs, "from", callerLine);*/

    if(self.channel && self.refs == 0) {
      var res = self.channel.leave(...args)
        .receive("ok", () => {
          if(Vue.Socket.channels[self.topic] && self.refs == 0) {
            delete Vue.Socket.channels[self.topic];
          }
        });
      return res;
    } else if(self.channel) {
      return undefined;
    }
    throw "Channel "+self.topic+" not found!";
  }

  self.push = function(...args) {
    if(args[0] == "save") {
      console.warn("Deprecated save. Use channel.save(payload) function.");
    }
    if(self.channel) {
      return self.channel.push(...args);
    }
    throw "Channel "+self.topic+" not found!";
  }

  self.setData = function(msg) {
    if(typeof(msg.data) != "undefined") Vue.set(self,"data",msg.data);
  }

  self.save = function(payload, set_data) {
    return new Promise((resolve, reject) => {
      var push = self.channel.push("save", payload)
      push.receive("ok", (msg) => {
        if(typeof(set_data) == "undefined" || set_data) Vue.set(self,"data",msg.data);
        resolve(msg, push);
      })
      push.receive("error", (msg) => {
        reject({type: "error", msg: msg});
      });
      push.receive("timeout", (msg) => {
        reject({type: "error", msg: msg});
      });
    });
  }

}



export default {
  install(Vue, connection, opts) {
    Vue.Socket = {
      socket: undefined,
      channels: {}
    };
    Vue.Socket.connect = function(params) {
      this.socket = new Socket(connection, _.merge(opts||{}, {params: params}));
      Vue.prototype.$socket = this.socket;
      this.socket.connect();
    }
    Vue.Socket.disconnect = function() {
      if (typeof(this.socket) != "undefined") {
        this.socket.disconnect();
      }
    }



    function Cloudserver() {
      var self = this;

      self.channels = {};

      self.channel = function(topic, opts, create_on_callbacks) {
        if(!_.isObject(opts)) create_on_callbacks = opts;
        var ch = Vue.Socket.channels[topic] || new Channel(Vue, Vue.Socket.socket, topic, opts);
        if (typeof(Vue.Socket.channels[topic]) == "undefined") Vue.Socket.channels[topic] = ch;
        if (typeof(self.channels[topic]) == "undefined") self.channels[topic] = ch;
        ch.__init__(create_on_callbacks);
        return ch;
      }

      self.list_channel = function(topic, opts, create_on_callbacks) {
        if(!_.isObject(opts)) create_on_callbacks = opts;
        opts = opts || {};
        opts.connection_type = "list";
        opts.type = "new";
        return self.channel(topic, opts, create_on_callbacks);
      }

      self.channel_new = function(topic, opts, create_on_callbacks) {
        if(!_.isObject(opts)) create_on_callbacks = opts;
        opts = opts || {};
        opts.type = "new";
        return self.channel(topic, opts, create_on_callbacks);
      }

    }


    let addListeners = function() {
      this.$cloudserver = new Cloudserver();
      if (this.$options["socket"]) {
        let conf = this.$options.socket;
        if(conf.open) {
          let func = conf.open.bind(this);
          Vue.Socket.socket.onOpen(func);
          conf.open.__binded = func;
        }
        if(conf.close) {
          let func = conf.close.bind(this);
          Vue.Socket.socket.onClose(func);
          conf.close.__binded = func;
        }
        if(conf.error) {
          let func = conf.error.bind(this);
          Vue.Socket.socket.onError(func);
          conf.error.__binded = func;
        }
        if(conf.message) {
          let func = conf.message.bind(this);
          Vue.Socket.socket.onMessage(func);
          conf.message.__binded = func;
        }
      }
    }

    let removeListeners = function() {
      if(this.$cloudserver) {
        Object.keys(this.$cloudserver.channels).forEach((ch_name) => {
          this.$cloudserver.channels[ch_name].leave();
          if(this.$cloudserver.channels[ch_name].refs == 0) {
            delete this.$cloudserver.channels[ch_name];
          }
        });
      }
      if (this.$options["socket"]) {
        let conf = this.$options.socket;
        let cbs = Vue.Socket.socket.stateChangeCallbacks;
        if(conf.open) {
          cbs.open = cbs.open.filter(item => item !== conf.open.__binded)
        }
        if(conf.close) {
          cbs.close = cbs.close.filter(item => item !== conf.close.__binded)
        }
        if(conf.error) {
          cbs.error = cbs.error.filter(item => item !== conf.error.__binded)
        }
        if(conf.message) {
          cbs.message = cbs.message.filter(item => item !== conf.message.__binded)
        }

      }
    };

    Vue.mixin({
      beforeCreate: addListeners,
      beforeDestroy: removeListeners
    });
  }
}
